export default "__VITE_ASSET__BQ4P9l4q__"